export default "__VITE_ASSET__E3gsfU9X__"